import Decimal from 'decimal.js';
import { StyledText } from '../../atoms/Text/StyledText';
import { StyledSumElement } from '../../atoms/UserPanelTrainerPay/StyledSumElement';
import { StyledSumRow } from '../../atoms/UserPanelTrainerPay/StyledSumRow';
import { useMemo } from 'react';
import { getString } from '../../../strings';

const CurrentMonthSummary = ({ hours }) => {
    const hoursAmount = useMemo(() => {
        if (!hours) return new Decimal(0);

        const firstMonth = Object.values(hours)[0];
        if (!firstMonth) return new Decimal(0);

        return (firstMonth.lessons || []).reduce((prev, cur) => {
            if (!cur) return prev;

            const value = cur.hours > 0 ? cur.hours : cur.half ? 0.5 : 0;

            return prev.plus(value);
        }, new Decimal(0));
    }, [hours]);

    const avgHoursForMonth = useMemo(() => {
        if (!hours) return new Decimal(0);

        const currentKey = Object.keys(hours)[0];
        if (!currentKey) return new Decimal(0);

        const [, currentMonth] = currentKey.split('-');
        const START_YEAR = 2023;
        const CURRENT_YEAR = new Date().getFullYear();

        const matchingMonths = Object.entries(hours).filter(([key]) => {
            const [year, month] = key.split('-').map(Number);
            return (
                year >= START_YEAR &&
                year < CURRENT_YEAR &&
                String(month).padStart(2, '0') === currentMonth
            );
        });

        if (!matchingMonths.length) return new Decimal(0);

        const total = matchingMonths.reduce((sum, [, arr]) => {
            const monthSum = (arr?.lessons || []).reduce((prev, cur) => {
                if (!cur) return prev;

                const value = cur.hours > 0 ? cur.hours : cur.half ? 0.5 : 0;

                return prev.plus(value);
            }, new Decimal(0));

            return sum.plus(monthSum);
        }, new Decimal(0));

        return total.div(matchingMonths.length).ceil();
    }, [hours]);

    return (
        <StyledSumElement>
            <StyledSumRow iscentertext>
                <StyledText
                    hasdeclaredfontsize="30px"
                    hasdeclaredfontweight="600"
                    hasdeclaredlineheight="1.4em"
                    hasdeclaredfontcolor="#6786BE"
                    hasdeclaredpadding="0 0 10px 0"
                    style={{ textTransform: 'uppercase' }}
                >
                    {getString('user_panel_all_trainer_pay_godzin')}:
                </StyledText>
                <StyledText
                    hasdeclaredfontsize="30px"
                    hasdeclaredfontweight="600"
                    hasdeclaredlineheight="1.4em"
                    hasdeclaredpadding="0 0 10px 0"
                    hasdeclaredtextalign="center"
                >
                    {hoursAmount.toString()}
                </StyledText>
            </StyledSumRow>
            <StyledSumRow iscentertext>
                <StyledText
                    hasdeclaredfontsize="18px"
                    hasdeclaredfontweight="600"
                    hasdeclaredlineheight="1.4em"
                    hasdeclaredfontcolor="#6786BE"
                >
                    {getString('user_panel_all_trainer_pay_avg')}:
                </StyledText>
                <StyledText
                    hasdeclaredfontsize="18px"
                    hasdeclaredfontweight="600"
                    hasdeclaredlineheight="1.4em"
                    hasdeclaredtextalign="center"
                >
                    {avgHoursForMonth.toString()}
                </StyledText>
            </StyledSumRow>
        </StyledSumElement>
    );
};

export default CurrentMonthSummary;
